import { createMigration } from './utils';

export const migrationTo9_190 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('sceneGroups').forEach((sceneGroup, i) => {
                map.setIn(['sceneGroups', i], this.migrateSceneGroup(sceneGroup));
            });
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
            const template = map.get('template');
            map.set('template', this.migrateTemplate(template));
        });
    },
    migrateTemplate(template) {
        return template;
    },
    migrateSceneGroup(sceneGroup) {
        return sceneGroup.withMutations(map => {
            const graphics = map.getIn(['captions', 'asset', 'style', 'graphics'], []) as [];
            graphics.forEach((graphic, index) => {
                const value = map.getIn(['captions', 'asset', 'style', 'graphics', index, 'level']) as string;
                map.setIn(['captions', 'asset', 'style', 'graphics', index, 'level'], value.toLowerCase());
            });
        });
    },
    migrateScene(scene) {
        return scene;
    },
});
